const a = {
  light4: "#F3FBF4",
  light3: "#E6F6EA",
  light2: "#C1EACA",
  light1: "#84D595",
  main: "#09AA2C",
  dark1: "#078021",
  dark2: "#045516",
  text: "#fff",
  25: "#EFFCF5",
  50: "#E5F8EE",
  100: "#BFEED4",
  200: "#94E3B8",
  300: "#69D79C",
  400: "#48CF86",
  500: "#28C671",
  600: "#1EB95E",
  700: "#18B154",
  800: "#0FA442",
  900: "#298D44",
  t8: "rgba(40, 198, 113, 0.08)",
  t16: "rgba(40, 198, 113, 0.16)",
  t24: "rgba(40, 198, 113, 0.24)",
  t32: "rgba(40, 198, 113, 0.32)",
  t40: "rgba(40, 198, 113, 0.4)",
  t48: "rgba(40, 198, 113, 0.48)"
}, f = {
  light4: "#F3FBF4",
  light3: "#E6F6EA",
  light2: "#C1EACA",
  light1: "#84D595",
  main: "#09AA2C",
  dark1: "#078021",
  dark2: "#045516",
  text: "#fff"
}, g = {
  25: "#F7F9FC",
  50: "#E5E8EF",
  100: "#BEC7D6",
  200: "#93A1BB",
  300: "#677B9F",
  400: "#475F8B",
  500: "#264376",
  600: "#223D6E",
  700: "#1C3463",
  800: "#172C59",
  900: "#0D1E46",
  t8: "rgba(38, 67, 118, 0.08)",
  t16: "rgba(38, 67, 118, 0.16)",
  t24: "rgba(38, 67, 118, 0.24)",
  t32: "rgba(38, 67, 118, 0.32)",
  t40: "rgba(38, 67, 118, 0.4)",
  t48: "rgba(38, 67, 118, 0.48)"
}, r = {
  light4: "#F2F8FF",
  light3: "#E5F1FF",
  light2: "#BFDBFF",
  light1: "#80B7FF",
  main: "#006FFF",
  dark1: "#0053BF",
  dark2: "#003880",
  text: "#fff",
  25: "#F6FAFF",
  50: "#E0EEFF",
  100: "#B3D4FF",
  200: "#80B7FF",
  300: "#4D9AFF",
  400: "#2685FF",
  500: "#006FFF",
  600: "#0067FF",
  700: "#005CFF",
  800: "#0040FF",
  900: "#0040FF",
  t8: "rgba(0, 111, 255, 0.08)",
  t16: "rgba(0, 111, 255, 0.16)",
  t24: "rgba(0, 111, 255, 0.24)",
  t32: "rgba(0, 111, 255, 0.32)",
  t40: "rgba(0, 111, 255, 0.4)",
  t48: "rgba(0, 111, 255, 0.48)"
}, b = {
  light4: "#fef3f4",
  light3: "#fde6e9",
  light2: "#fac2c8",
  light1: "#f68492",
  main: "#EC0A25",
  dark1: "#b1071c",
  dark2: "#760512",
  text: "#fff",
  25: "#FFEDF0",
  50: "#FFE1E6",
  100: "#FEAEBB",
  200: "#FD93A5",
  300: "#FD798F",
  400: "#FD4462",
  500: "#CA102F",
  600: "#B5102B",
  700: "#A80A24",
  800: "#8C081E",
  900: "#700618",
  t8: "rgba(202, 16, 47, 0.08)",
  t16: "rgba(202, 16, 47, 0.16)",
  t24: "rgba(202, 16, 47, 0.24)",
  t32: "rgba(202, 16, 47, 0.32)",
  t40: "rgba(202, 16, 47, 0.4)",
  t48: "rgba(202, 16, 47, 0.48)"
}, i = {
  light4: "#fffdf2",
  light3: "#fffbe5",
  light2: "#fff5bf",
  light1: "#ffec80",
  main: "#ffd800",
  dark1: "#bfa200",
  dark2: "#806c00",
  text: "#fff",
  25: "#FFFEF6",
  50: "#FFFCE8",
  100: "#FFFCE8",
  200: "#FFF6C6",
  300: "#FFF1A1",
  400: "#FFEB7B",
  500: "#FFE242",
  600: "#FFCF1D",
  700: "#F5C513",
  800: "#E5B916",
  900: "#D3AA12",
  t8: "rgba(255, 226, 66, 0.08)",
  t16: "rgba(255, 226, 66, 0.16)",
  t24: "rgba(255, 226, 66, 0.24)",
  t32: "rgba(255, 226, 66, 0.32)",
  t40: "rgba(255, 226, 66, 0.4)",
  t48: "rgba(255, 226, 66, 0.48)"
}, l = {
  light4: "#fff9f2",
  light3: "#fff3e5",
  light2: "#ffe2bf",
  light1: "#ffc480",
  main: "#ff8900",
  dark1: "#bf6700",
  dark2: "#804500",
  text: "#fff",
  25: "#FFF8EF",
  50: "#FFF1E0",
  100: "#FFDCB3",
  200: "#FFC480",
  300: "#FFAC4D",
  400: "#FF9B26",
  500: "#FF8900",
  600: "#FC6B00",
  700: "#E25A00",
  800: "#C64F00",
  900: "#AA4400",
  t8: "rgba(255, 137, 0, 0.08)",
  t16: "rgba(255, 137, 0, 0.16)",
  t24: "rgba(255, 137, 0, 0.24)",
  t32: "rgba(255, 137, 0, 0.32)",
  t40: "rgba(255, 137, 0, 0.4)",
  t48: "rgba(255, 137, 0, 0.48)"
}, E = {
  light4: "#F3FBF4",
  light3: "#E6F6EA",
  light2: "#C1EACA",
  light1: "#84D595",
  main: "#09AA2C",
  dark1: "#0D182B",
  dark2: "#09101C",
  text: "#fff",
  25: "#EFFCF5",
  50: "#BFEED4",
  100: "#69D79C",
  200: "#156A2C",
  300: "#28C671",
  400: "#1EB95E",
  500: "#18B154",
  600: "#0FA442",
  700: "#298D44",
  800: "#26823F",
  900: "#156A2C",
  t8: "rgba(24, 177, 84, 0.08)",
  t16: "rgba(24, 177, 84, 0.16)",
  t24: "rgba(24, 177, 84, 0.24)",
  t32: "rgba(24, 177, 84, 0.32)",
  t40: "rgba(24, 177, 84, 0.4)",
  t48: "rgba(24, 177, 84, 0.48)"
}, F = {
  light4: "#fcfcfc",
  light3: "#f9f9f9",
  light2: "#efefef",
  light1: "#dfdfdf",
  main: "#bfbfbf",
  dark1: "#8f8f8f",
  dark2: "#606060",
  text: "#212121",
  25: "#FAFBFC",
  50: "#F9FAFB",
  100: "#F2F4F7",
  200: "#E4E7EC",
  300: "#D0D5DD",
  400: "#98A2B3",
  500: "#667085",
  600: "#475467",
  700: "#344054",
  800: "#1D2939",
  900: "#101828",
  t8: "rgba(102, 112, 133, 0.08)",
  t16: "rgba(102, 112, 133, 0.16)",
  t24: "rgba(102, 112, 133, 0.24)",
  t32: "rgba(102, 112, 133, 0.32)",
  t40: "rgba(102, 112, 133, 0.4)",
  t48: "rgba(102, 112, 133, 0.48)"
}, e = {
  light4: "#F3F4F5",
  light3: "#E7E9EB",
  light2: "#C4C7CD",
  light1: "#888F9C",
  main: "#122039",
  dark1: "#0D182B",
  dark2: "#09101C",
  text: "#fff"
}, t = {
  25: "#FFFFFF",
  50: "#EDEDEC",
  100: "#CCCBC8",
  200: "#BBBAB6",
  300: "#999793",
  400: "#767571",
  500: "#666666",
  600: "#4D4D4D",
  700: "#333333",
  800: "#212121",
  900: "#000000",
  t8: "rgba(102, 102, 102, 0.08)",
  t16: "rgba(102, 102, 102, 0.16)",
  t24: "rgba(102, 102, 102, 0.24)",
  t32: "rgba(102, 102, 102, 0.32)",
  t40: "rgba(102, 102, 102, 0.4)",
  t48: "rgba(102, 102, 102, 0.48)"
}, C = {
  light4: "#f4f4f4",
  light3: "#e9e9e9",
  light2: "#c7c7c7",
  light1: "#909090",
  main: "#212121",
  dark1: "#1c1c1c",
  dark2: "#121212",
  text: "#fff"
}, d = {
  light4: "#fefefe",
  light3: "#FEFEFD",
  light2: "#FCFCFA",
  light1: "#FAF9F5",
  main: "#f5f3eb",
  dark1: "#e6e6e6",
  dark2: "#b3b3b3",
  text: "#212121"
}, h = {
  light4: "#f2f2f2",
  light3: "#e6e6e6",
  light2: "#d9d9d9",
  light1: "#bfbfbf",
  main: "#fff",
  dark1: "#fafafa",
  dark2: "#f2f2f2",
  text: "#212121"
}, B = {
  default: t[25],
  neutral: t[25],
  disabled: F[300],
  dark: t[50]
}, A = {
  default: t[25],
  neutral: t[25],
  disabled: F[300],
  dark: t[50]
}, n = {
  default: t[800],
  neutral: t[800],
  disabled: F[700],
  dark: t[50]
}, c = {
  primary: a,
  secondary: f,
  green: E,
  blue: r,
  neutral: t,
  orange: l,
  yellow: i,
  red: b,
  navy: g,
  gray: F,
  slate: e,
  black: C,
  beige: d,
  white: h,
  background: B,
  foreground: A,
  text: n
};
export {
  c as colors
};
//# sourceMappingURL=colors.es.js.map
